import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clear } from "../../Services/Storage";
import NavDropdownMenu from "./NavDropdownMenu";

export const AppNav = () => {
  const [name, setName] = React.useState("");
  const admin = useSelector((x) => x.Admin);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = React.useState(false);

  React.useEffect(() => {
    if (admin) {
      setName(`${admin?.f_name} ${admin?.l_name}`);
    }
  }, [admin]);
  const Logout = () => {
    dispatch({ type: "setToken", payload: null });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setLoggedIn", payload: false });
    dispatch({ type: "setZone", payload: null });
    dispatch({ type: "setCustomer", payload: null });
    dispatch({ type: "setAddress", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({ type: "setOngoingOrders", payload: null });
    dispatch({ type: "setNote", payload: null });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setCoupon", payload: null });
    dispatch({ type: "setRole", payload: null });
    dispatch({ type: "setAdmin", payload: null });
    clear();
    navigate("/", { replace: true });
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <>
      {!Boolean(
        ["edit", "summary", "review"].find((x) => location.pathname.includes(x))
      ) ? (
        <Navbar
          collapseOnSelect
          expand="lg"
          className="bg-white app-nav-container"
        >
          <Container fluid className="d-flex align-items-center flex-wrap">
            <Navbar.Brand as={Link} to="/admin" className="p-0">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                style={{ height: "33.19px", width: "198px" }}
                alt=""
              />
            </Navbar.Brand>
            <Navbar.Collapse
              className="d-lg-flex align-items-center d-none"
              style={{ marginLeft: "68px" }}
            >
              <Nav className="me-auto">
                <Nav.Link
                  className="pb-0 d-flex justify-content-between align-items-center flex-column fw-normal"
                  style={{ paddingBottom: "23px", fontSize: "14px" }}
                  as={Link}
                  to="/admin/orders"
                >
                  Orders
                  {location.pathname == "/admin/orders" ? (
                    <span className="app-nav-active"></span>
                  ) : null}
                </Nav.Link>
                <Nav.Link
                  className="pb-0 d-flex justify-content-between align-items-center flex-column fw-normal"
                  style={{ paddingBottom: "23px", fontSize: "14px" }}
                  as={Link}
                  to="/admin/customers"
                >
                  Customers
                  {location.pathname == "/admin/customers" ? (
                    <span className="app-nav-active"></span>
                  ) : null}
                </Nav.Link>
              </Nav>
              <Nav className="ms-auto">
                <NavDropdownMenu name={name} />
              </Nav>
            </Navbar.Collapse>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className="ms-auto"
              onClick={toggleMenu}
            />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-false`}
              aria-labelledby={`offcanvasNavbarLabel-expand-false`}
              placement="end"
              className="d-lg-none"
              restoreFocus={false}
              show={menuOpen}
              onHide={toggleMenu}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                    style={{ height: "30px" }}
                    alt=""
                  />
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <h5 className="fw-semibold">Welcome, {name}</h5>
                <hr />
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link
                    className=" d-flex align-items-center fw-normal"
                    onClick={toggleMenu}
                    style={{
                      fontSize: "14px",
                      padding: "16px 20px",
                    }}
                    as={Link}
                    to="/admin/orders"
                  >
                    {/* <img
                    src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon.svg"}
                    style={{ marginRight: "11px" }}
                    alt=""
                  /> */}
                    Orders
                  </Nav.Link>
                  <Nav.Link
                    className=" d-flex align-items-center fw-normal"
                    onClick={toggleMenu}
                    style={{
                      fontSize: "14px",
                      padding: "16px 20px",
                    }}
                    as={Link}
                    to="/admin/customers"
                  >
                    {/* <img
                    src={process.env.PUBLIC_URL + "/assets/svgs/icons/bag-icon.svg"}
                    style={{ marginRight: "11px" }}
                    alt=""
                  /> */}
                    Customers
                  </Nav.Link>

                  <hr className="mt-0" />
                  <Nav.Link
                    className=" d-flex align-items-center fw-normal"
                    onClick={() => {
                      toggleMenu();
                      Logout();
                    }}
                    style={{
                      fontSize: "14px",
                      padding: "16px 20px",
                    }}
                    as={Link}
                  >
                    <img
                      src={process.env.PUBLIC_URL +"/assets/svgs/icons/logout.svg"}
                      style={{ marginRight: "11px" }}
                      alt=""
                    />
                    Logout
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ) : null}
    </>
  );
};
